import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { CommonIP, DisplayableFieldResponse, WsFile } from '@model/ftf-api.model';

import { IpDetailComponent } from '../../../shared/components/ip-detail/ip-detail.component';
import { DataTransformService } from '../../../shared/service/data-transform.service';

export interface UploadVersionDialogData {
  item: CommonIP;
  doc: WsFile;
  fileName: string;
}

/**
 * Upload Version Confirmation Dialog Component
 *
 * @export
 * @class UploadVersionDialogComponent
 * @typedef {UploadVersionDialogComponent}
 */
@Component({
  selector: 'app-upload-version-confirm-dialog',
  templateUrl: './upload-version-confirm-dialog.component.html',
  styleUrls: ['./upload-version-confirm-dialog.component.scss'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, IpDetailComponent, MatDialogActions, MatButton, MatDialogClose],
})
export class UploadVersionDialogComponent {
  dialogRef = inject<MatDialogRef<UploadVersionDialogComponent>>(MatDialogRef);
  private dataTransformService = inject(DataTransformService);
  data = inject<UploadVersionDialogData>(MAT_DIALOG_DATA);

  item: CommonIP;
  doc: WsFile;
  fileName: string;
  detail: DisplayableFieldResponse;

  constructor() {
    const { data } = this;

    this.item = data.item;
    this.doc = data.doc;
    this.fileName = data.fileName;
    this.detail = this.dataTransformService.displayableFileDetails(this.doc);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
